import './style.css';
function UnderConstruction() {
    return <div className="UnderConstruction">UnderConstruction</div>;
}

export default UnderConstruction;
